import { Chart, Eye, MouseCircle, Profile2User } from 'iconsax-react';
import { StatCard } from '@src/features/dashboard/components/stats-card';
import { useGetOrgId } from '@shared/hooks/use-get-org-id';
import announcementsApi from '../../services/announcements-api';
import {
  formatCompactCount,
  formatCtrDisplay,
} from '../../utils/format-announcement-stats';

export function AnnouncementOverviewStats() {
  const orgId = useGetOrgId();
  const { data, isLoading } = announcementsApi.useGetStats(orgId);

  return (
    <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4'>
      <StatCard
        title='Total Views'
        value={formatCompactCount(data?.total_views)}
        className='h-[101px] pt-3 '
        cardContentClassName='gap-0'
        valueClassName='text-secondary-1000 font-semibold'
        icon={
          <Eye
            className='text-primary-1000'
            size={24}
            variant='Outline'
          />
        }
        isLoading={isLoading}
      />
      <StatCard
        title='Students Reached'
        value={formatCompactCount(data?.students_reached)}
        className='h-[101px] pt-3'
        cardContentClassName='gap-0'
        valueClassName='text-primary-800'
        icon={
          <Profile2User
            className='text-primary-1000'
            size={24}
            variant='Outline'
          />
        }
        isLoading={isLoading}
      />
      <StatCard
        title='CTA Clicks'
        value={formatCompactCount(data?.cta_clicks)}
        className='h-[101px] pt-3'
        cardContentClassName='gap-0'
        valueClassName='text-green-500'
        icon={
          <MouseCircle
            className='text-primary-1000'
            size={24}
            variant='Outline'
          />
        }
        isLoading={isLoading}
      />
      <StatCard
        title='Avg CTR'
        value={formatCtrDisplay(data?.avg_ctr)}
        className='h-[101px] pt-3'
        cardContentClassName='gap-0'
        valueClassName='text-yellow-500'
        icon={
          <Chart
            className='text-primary-1000'
            size={24}
            variant='Linear'
          />
        }
        isLoading={isLoading}
      />
    </div>
  );
}
